export default "__VITE_ASSET__7sPVxlAe__"